<template>
  <div>
    <div v-if="tabName !== 'traceroute'">
      <el-row type="flex" justify="space-between" class="title-bar">
        <div class="vertical-center-box">
          <div v-if="agentStatus === '1'" class="vertical-center-box">
            <i class="fas fa-check-circle" style="font-size:16px;color:#2b68be">  수집서버 정상
              <span v-if="tableData.length > 0 && !isLoading" style="color:#303133">
                ( 응답 : {{successCount}} 건 | 미응답 : {{failCount}} 건 )
              </span>
            </i>
          </div>
          <div v-else-if="agentStatus === '0'" class="vertical-center-box">
            <i class="fas fa-exclamation-circle" style="font-size:16px;color:#eb534e">  수집서버의 상태를 확인해주세요 ( 마지막 수집시간 : {{diffTime}} 전 )</i>
          </div>
        </div>
        <div class="vertical-center-box">
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :class="getTableClass()" v-loading="isLoading" ref="table" border header-align="center" :data="tableData"
      :columns="tableColumns" pagination :show-custom-header="true" :show-search-tool="showSearchTool">
        <template slot-scope="scope" slot="result-slot">
          <i v-if="scope.row.result === '1'" class="fas fa-circle" style="color:#2b68be"></i>
          <i v-else class="fas fa-circle" style="color:#eb534e"></i>
        </template>
        <template slot-scope="scope" slot="ipaddress-slot">
          {{ scope.row.ipaddress }}
        </template>
      </el-table-wrapper>
    </div>
    <div v-else>
      <el-row type="flex" justify="start" class="title-bar" style="height:31px">
        <div class="vertical-center-box">
          <span v-if="agentStatus === '1'">
            <i class="fas fa-check-circle" style="font-size:16px;color:#2b68be">  수집서버 정상</i>
            <span v-if="tableData.length > 0" style="font-size:16px;">
            </span>
          </span>
          <span v-else-if="agentStatus === '0'">
            <i class="fas fa-exclamation-circle" style="font-size:16px;color:#eb534e">  수집서버의 상태를 확인해주세요 ( 마지막 수집시간 : {{diffTime}} 전 )</i>
          </span>
        </div>
      </el-row>
      <el-input v-loading="isLoading" type="textarea" v-model="resultData" class="ip-scan-textarea" readonly></el-input>
    </div>
  </div>
</template>

<script>
import { isEqual, isNil } from 'lodash';
import { getDuration } from '@/utils/date';

export default {
  name: 'WScanCommonTable',
  props: {
    tabInfo: {
      type: Object,
      default: () => {},
    },
    scanType: {
      type: String,
      default: 'SPOT',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    resultData: {
      type: String,
      default: null,
    },
    agentStatus: {
      type: String,
      default: null,
    },
    agentDiffTime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tabName() {
      return this.tabInfo.name;
    },
    active() {
      return this.tabInfo.active;
    },
    successCount() {
      const tableData = this.tableData;
      if (!isNil(tableData)) {
        return tableData.filter((item) => item.result === '1').length;
      }
      return 0;
    },
    failCount() {
      const tableData = this.tableData;
      if (!isNil(tableData)) {
        return tableData.filter((item) => item.result === '0').length;
      }
      return 0;
    },
    diffTime() {
      const agentDiffTime = this.agentDiffTime;
      return getDuration(agentDiffTime * 1000);
    },
  },
  data() {
    return {
      showSearchTool: false,
      tableColumns: [],
      responseStatusColumn: {
        prop: 'result',
        label: '응답 상태',
        scopedSlot: 'result-slot',
        align: 'center',
        width: 150,
        sortable: true,
        filters: [
          {
            text: '성공',
            value: '1',
          },
          {
            text: '실패',
            value: '0',
          },
        ],
      },
      ipaddressColumn: {
        prop: 'ipaddress',
        label: 'IP 주소',
        sortable: true,
        searchable: true,
        sortProp: 'orderbyIndex',
        // scopedSlot: 'ipaddress-slot',
      },
      responseTimeColumn: {
        prop: 'value',
        label: '응답 속도(ms)',
        width: 150,
        sortable: true,
        searchable: true,
      },
      portColumn: {
        prop: 'ipaddress',
        label: '포트',
        sortable: true,
        searchable: true,
        sortProp: 'orderbyIndex',
      },
    };
  },
  watch: {
    scanType() {
      const tabName = this.tabName;
      if (isEqual(tabName, 'tcp') || isEqual(tabName, 'udp')) {
        this.tableColumns = [];
        this.$nextTick(() => {
          this.tableColumns = this.getTableColumns();
        });
      }
    },
  },
  mounted() {
    this.tableColumns = this.getTableColumns();
  },
  methods: {
    getTableColumns() {
      const columns = [
        this.responseStatusColumn,
      ];
      const tabName = this.tabName;
      if (isEqual(tabName, 'icmp') || isEqual(tabName, 'snmp')) {
        columns.push(this.ipaddressColumn);
        columns.push(this.responseTimeColumn);
      } else if (isEqual(tabName, 'tcp') || isEqual(tabName, 'udp')) {
        if (isEqual(this.scanType, 'SPOT')) {
          columns.push(this.portColumn);
        } else {
          columns.push(this.ipaddressColumn);
        }
        columns.push(this.responseTimeColumn);
      } else {
        columns.push(this.ipaddressColumn);
        columns.push(this.responseTimeColumn);
      }
      return columns;
    },
    getTableClass() {
      let className = 'inner_popup1';
      if (this.tabName === 'snmp') {
        className = 'inner_popup2';
        if (this.showSearchTool) {
          className = 'inner_popup4';
        }
      } else if (this.showSearchTool) {
        className = 'inner_popup3';
      }
      return className;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/IpScan/components/ScanCommonTable.vue